<template>
  <section>
    <b-modal
      :visible="visible"
      hide-footer
      button-size="sm"
      size="xl"
      modal-cancel="false"
      no-close-on-backdrop
      @close="close"
      id="registration-list"
    >
      <template v-slot:modal-title>Programación de cursos</template>
      <section class="container-fluid">
        <div class="row">
          <div class="col-12 col-xl-9">
            <template v-if="student.id != 0">
              <span>
                <b>Estudiante:</b>
                {{ student.person.last_name }}
                {{ student.person.first_name }}
              </span>
            </template>
          </div>
          <div class="col-12 col-xl-3">
            <div class="row">
              <!-- Gestión -->
              <div class="col-10 col-xl-10">
                <div class="form-group">
                  <label class="control-label" for="courses_offered_year"
                    >Gestión:</label
                  >
                  <b-form-select
                    v-model="columnFilter.courses_offered_year"
                    :options="coursesOfferedYearsOptions"
                    id="courses_offered_year"
                    size="sm"
                    @change="filterTable"
                  >
                  </b-form-select>
                </div>
              </div>
              <div class="col-2 col-xl-2">
                <div class="card-header-actions">
                  <b-button
                    @click="modalAddRegistration()"
                    variant="success"
                    class="mt-3"
                    size="sm"
                    title="Nueva programación"
                    v-if="student.enabled"
                  >
                    <CIcon size="sm" name="cil-plus" />
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CDataTable
          class="table-bordered c-table c-table-main"
          :hover="true"
          :striped="true"
          :bordered="true"
          :small="true"
          :items="items"
          :fields="fields"
          :sorter="{ external: true, resetable: true }"
          @update:sorter-value="filterTable"
          :columnFilter="{ external: true, lazy: true }"
          @update:column-filter-value="filterTable"
          :column-filter-value.sync="columnFilter"
          :loading="loading"
        >
          <template #no-items-view>
            <div class="no-items-view">
              {{
                loading ? "Cargando datos..." : "No existen cursos programados"
              }}
              <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
            </div>
          </template>
          <!-- filters -->
          <template #enabled-filter>
            <v-select
              :options="enabledOptions"
              label="label"
              :reduce="(enabledOption) => enabledOption.code"
              v-model="columnFilter.enabled"
              @input="filterTable"
            ></v-select>
          </template>
          <template #detail-filter>
            <b-button
              @click="reload"
              variant="secondary"
              size="sm"
              title="Recargar tabla"
            >
              <CIcon size="sm" name="cil-reload" />
            </b-button>
            <b-button
              @click="clean"
              variant="secondary"
              size="sm"
              title="Limpiar filtros"
            >
              <CIcon size="sm" name="cil-filter-x" />
            </b-button>
          </template>
          <!-- data -->
          <template #id="{ index }">
            <td>{{ (page - 1) * limit + (index + 1) }}</td>
          </template>
          <template #course_name="{ item }">
            <td>
              <span>
                {{ item.course_name }}
              </span>
              <br />
              <span>
                Paralelo:
                {{
                  item.courses_offered_parallel == "NONE"
                    ? "Ninguno"
                    : item.courses_offered_parallel
                }}
              </span>
              <br />
              <span
                >Profesor:
                {{
                  item.teacher_fullname == " "
                    ? "--Sin asignar--"
                    : item.teacher_fullname
                }}</span
              >
              <br />
              <span>Horario: {{ item | time_courses_offered }}</span>
            </td>
          </template>
          <template #courses_offered_period="{ item }">
            <td>
              Gestión: {{ item.courses_offered_year }}
              <br />
              Periodo:
              {{ item.courses_offered_period | period }}
            </td>
          </template>

          <template #tuition_price="{ item }">
            <td class="text-right">
              {{ item.tuition_price | currency }}
            </td>
          </template>
          <template #sale_total_fines="{ item }">
            <td class="text-right">
              <span v-if="item.sale_total_fines !== null">
                {{ item.sale_total_fines | currency }}
              </span>
              <span v-else> - </span>
            </td>
          </template>
          <template #sale_total_paid="{ item }">
            <td class="text-right">
              <span v-if="item.sale_total_paid !== null">
                {{ item.sale_total_paid | currency }}
              </span>
              <span v-else> - </span>
            </td>
          </template>
          <template #sale_id="{ item }">
            <td style="text-align: center">
              <div v-if="item.tuition_price > 0">
                <span class="badge bg-success" v-if="item.paid == true"
                  >Pagada</span
                >
                <span class="badge bg-danger" v-else>No Pagada</span>
              </div>
            </td>
          </template>

          <template #detail="{ item }">
            <td>
              <b-button-group size="xs">
                <b-button
                  v-if="item.paid == false && item.tuition_price > 0"
                  variant="warning"
                  title="Pagar Pensión"
                  size="sm"
                  @click="modalAddSaleRegistration(item.id)"
                >
                  <CIcon size="sm" name="cil-cash" />
                </b-button>
                <b-button
                  variant="warning"
                  title="Modificar programación"
                  @click="modalEdit(item.id)"
                >
                  <CIcon size="sm" name="cil-pencil" />
                </b-button>
                <b-button
                  v-auth-roles="{
                    user: userAuth,
                    roles: [roles.ROLE_ADMINISTRATOR],
                  }"
                  v-if="item.grade_id == null && item.tuition_price >= 0"
                  variant="success"
                  title="Subir nota"
                  @click="modalGradeAdd(item.id, item.course_offered_id)"
                >
                  <CIcon size="sm" name="cil-note-add" />
                </b-button>
                <b-button
                  v-auth-roles="{
                    user: userAuth,
                    roles: [roles.ROLE_ADMINISTRATOR],
                  }"
                  v-if="item.grade_id !== null && item.tuition_price >= 0"
                  variant="warning"
                  title="Modificar nota "
                  @click="modalGradeEdit(item.id, item.grade_id)"
                >
                  <CIcon size="sm" name="cil-note-add" />
                </b-button>
                <b-button
                  variant="danger"
                  title="Anular"
                  @click="modalAnnulled(item.id)"
                >
                  <CIcon size="sm" name="cil-x-circle" />
                </b-button>
              </b-button-group>
            </td>
          </template>
        </CDataTable>
        <div>
          <CPagination
            :activePage.sync="page"
            :pages="pages"
            size="sm"
            align="center"
            @update:activePage="updateTable"
          />
          <TableRecords
            :total="total"
            :loading="loading"
            :from="from"
            :to="to"
            :page="page"
          />
        </div>
      </section>
    </b-modal>
    <section v-if="modShowRegistrationAdd">
      <RegistrationAddModal
        :student_id="student.id"
        :modShowRegistrationAdd="modShowRegistrationAdd"
        @registrationAddModal="afterRegistrationAdd"
      ></RegistrationAddModal>
    </section>
    <section v-if="modShowSaleRegistrationAdd">
      <SaleRegistrationAddModal
        :student_id="student.id"
        :registration_id="registration_id"
        :modShowSaleRegistrationAdd="modShowSaleRegistrationAdd"
        @saleRegistrationAddModal="afterSaleRegistrationAdd"
      ></SaleRegistrationAddModal>
    </section>
    <section v-if="modShowRegistrationEditMod">
      <RegistrationEditModal
        :student_id="student.id"
        :registration_id="registration_id"
        :modShowRegistrationEditMod="modShowRegistrationEditMod"
        @registrationEditModal="afterEditModal"
      ></RegistrationEditModal>
    </section>
    <section v-if="modShowDelregistration">
      <RegistrationDeleteModal
        :registration_id="registration_id"
        :modShowDelregistration="modShowDelregistration"
        @registrationDeleteModal="afterRegistrationDeleteModal"
      ></RegistrationDeleteModal>
    </section>
    <section v-if="modShowAddGrade">
      <GradeAddModal
        :id_student="student.id"
        :course_offered_id="course_offered_id"
        :registration_id="registration_id"
        :modShowAddGrade="modShowAddGrade"
        @gradeAddModal="afterGradeAddModal"
      ></GradeAddModal>
    </section>
    <section v-if="modShowEditGrade">
      <GradeEditModal
        :id_student="student.id"
        :registration_id="registration_id"
        :grade_id="grade_id"
        :modShowEditGrade="modShowEditGrade"
        @gradeEditModal="afterGradeEditModal"
      ></GradeEditModal>
    </section>
  </section>
</template>
<script>
import {
  BAlert,
  BModal,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import Registrations from "@/plugins/services/registrations";
import Students from "@/plugins/services/students";
// components
import RegistrationAddModal from "@/entities/registrations/RegistrationAddModal";
import SaleRegistrationAddModal from "@/entities/sales/SaleRegistrationAddModal";
import RegistrationDeleteModal from "@/entities/registrations/RegistrationDeleteModal";
import RegistrationEditModal from "@/entities/registrations/RegistrationEditModal";
import GradeAddModal from "@/entities/grades/GradeAddModal";
import GradeEditModal from "@/entities/grades/GradeEditModal";

export default {
  name: "RegistrationListModal",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    BFormSelect,
    BFormSelectOption,
    TableRecords,
    RegistrationAddModal,
    SaleRegistrationAddModal,
    RegistrationDeleteModal,
    RegistrationEditModal,
    GradeAddModal,
    GradeEditModal,
  },
  props: {
    modShowRegistrationList: { type: Boolean, required: true },
    student_id: { type: Number, required: true },
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width: 8px;",
        },
        {
          key: "course_name",
          label: "Curso",
          _style: "min-width: 150px;",
        },
        {
          key: "syllabus_description",
          label: "Pensum",
          _style: "width: 15%;",
        },
        {
          key: "courses_offered_period",
          label: "Periodo",
          filter: false,
          _style: "width: 10%;",
        },
        {
          key: "syllabus_tuition_name",
          label: "Tipo de pensión",
          _style: "width: 15%;",
        },
        {
          key: "tuition_price",
          label: "Precio pensión",
          filter: false,
          _style: "width: 8%;",
        },
        {
          key: "sale_total_fines",
          label: "Multas pagadas",
          filter: false,
          _style: "width: 8%;",
        },
        {
          key: "sale_total_paid",
          label: "Total pagado",
          filter: false,
          _style: "width: 8%;",
        },
        {
          key: "sale_id",
          label: "Estado",
          sorter: false,
          filter: false,
          _style: "width: 6%;",
        },
        {
          key: "detail",
          label: "Acciones",
          sorter: false,
          _style: "width: 110px;",
        },
      ],
      student: {
        id: 0,
        enabled: false,
      },
      items: [],
      columnFilter: {
        asc: false,
        enabled: true,
        column: "created_at",
      },
      enabledOptions: Constants.enabledOptions,
      roles: Constants.roles,
      coursesOfferedYearsOptions: [],
      page: 0,
      pages: 0,
      limit: 20,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      dataEmit: { modalShow: false, data: null },
      registration_id: 0,
      course_offered_id:0,
      grade_id: 0,
      modShowRegistrationAdd: false,
      modShowSaleRegistrationAdd: false,
      modShowDelregistration: false,
      modShowRegistrationEditMod: false,
      modShowAddGrade: false,
      modShowEditGrade: false,
    };
  },
  mounted() {
    this.columnFilter.courses_offered_year = Utils.getYear(this.userAuth.now);
    this.columnFilter.student_id = this.student_id;
    this.getStudent(this.student_id);
    this.getAll(this.columnFilter);
    this.getCoursesOfferedYears();
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowRegistrationList;
    },
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Registrations.all(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        student_id: this.student_id,
        asc: false,
        enabled: true,
        courses_offered_year: Utils.getYear(this.userAuth.now),
        column: "created_at",
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter, this.page);
    },
    getStudent(id) {
      Students.getOne(id)
        .then((res) => {
          this.student = res.data;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Estudiante no encontrado.");
            this.closeModal();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal();
          }
          this.dataLoader = false;
        });
    },
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears(this.userAuth.now);
    },
    modalAddRegistration() {
      this.modShowRegistrationAdd = true;
    },
    afterRegistrationAdd(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowRegistrationAdd = response.modalShow;
    },
    modalAddSaleRegistration(id) {
      this.registration_id = id;
      this.modShowSaleRegistrationAdd = true;
    },
    afterSaleRegistrationAdd(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowSaleRegistrationAdd = response.modalShow;
    },
    modalAnnulled(id) {
      this.registration_id = id;
      this.modShowDelregistration = true;
    },
    afterRegistrationDeleteModal(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowDelregistration = response.modalShow;
    },
    modalEdit(id) {
      this.registration_id = id;
      this.modShowRegistrationEditMod = true;
    },
    afterEditModal(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowRegistrationEditMod = response.modalShow;
    },
    modalGradeAdd(id,course_offered_id) {
      this.registration_id = id;
      this.course_offered_id= course_offered_id;
      this.modShowAddGrade = true;
    },
    afterGradeAddModal(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowAddGrade = response.modalShow;
    },
    modalGradeEdit(id, grade_id) {
      this.registration_id = id;
      this.grade_id = grade_id;
      this.modShowEditGrade = true;
    },
    afterGradeEditModal(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowEditGrade = response.modalShow;
    },
    closeModal(data = null) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.$emit("registrationListModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
